import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronRight } from "@air/next-icons";
import { memo, useCallback } from "react";
import { SearchCommandItem } from "~/components/SearchCommand/SearchCommandItem";
export const SearchCommandSavedFilterListItem = /*#__PURE__*/ memo((param)=>{
    let { savedFilter, onSelect: _onSelect } = param;
    const onSelect = useCallback(()=>_onSelect(savedFilter), [
        savedFilter,
        _onSelect
    ]);
    return /*#__PURE__*/ _jsxs(SearchCommandItem, {
        "data-type": "saved-filter",
        onSelect: onSelect,
        value: savedFilter.id,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "flex size-10 shrink-0 items-center justify-center rounded bg-grey-4 text-20 transition-colors group-data-[selected=true]/command-item:bg-grey-5",
                children: savedFilter.icon
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "grow px-1",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "truncate text-14 font-medium",
                    children: savedFilter.name
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex size-8 shrink-0 items-center",
                children: /*#__PURE__*/ _jsx(ChevronRight, {
                    className: "w-4 text-grey-12"
                })
            })
        ]
    });
});
SearchCommandSavedFilterListItem.displayName = "SearchCommandSavedFilterListItem";
